import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-77-small', 'Number77Small', [["path",{"d":"M14 8h4l-2 8","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]);